module.exports = __webpack_public_path__ + "img/whatsapp.fe6c445d.png";